<div class="card w-100 h-100" style="cursor: pointer; transition: transform 0.2s ease-in-out;">
  <div class="card-body d-flex flex-row flex-nowrap align-items-center gap-3 p-3">
    <div class="progress-card-icon flex-shrink-0" *ngIf="past_completions || icon">
      <!-- Icon URL -->
      <img *ngIf="icon else iconDefault" class="progress-card-image" height="48" width="48" [src]="icon"
           [alt]="description">
      <ng-template #iconDefault>
        <i class="bi bi-award d-flex align-items-center justify-content-center progress-card-image"></i>
      </ng-template>
      <!-- Past completions -->
      <small *ngIf="past_completions && occurrence === 'multiple'" class="mt-1 fw-bold text-uppercase">
        Level {{ past_completions + 1 || 1 }}
      </small>
    </div>
    
    <div class="d-flex flex-column flex-grow-1">
      <!-- Name -->
      <h6 *ngIf="name" class="card-title fw-bold mb-2 line-clamp-2">{{ name }}</h6>
      <!-- Description -->
      <p *ngIf="description" class="card-text mb-2 line-clamp-2">{{ description }}</p>
      
      <!-- Progress bar - only show if not a completed single occurrence challenge -->
      <ng-container *ngIf="completed_steps != null && total_steps != null && !(past_completions > 0 && occurrence === 'single')">
        <div class="d-flex flex-row flex-nowrap align-items-center gap-3">
          <div class="progress flex-grow-1" style="height: 1rem;">
            <!-- Divide total steps by completed steps to get the percentage width for progress bar -->
            <div class="progress-bar progress-bar-striped" 
                 role="progressbar"
                 [style.width.%]="(completed_steps / total_steps) * 100"
                 [attr.aria-valuenow]="completed_steps"
                 [attr.aria-valuemin]="0"
                 [attr.aria-valuemax]="total_steps">
            </div>
          </div>
          <!-- Completed steps/Total Steps -->
          <small class="fw-bold text-nowrap">{{ completed_steps }}/{{ total_steps }}</small>
        </div>
      </ng-container>
    </div>
  </div>
</div>
  